import { Component, OnInit, ViewChild } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/custom-validators';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { TutorService } from 'src/app/services/tutor.service';
import { SupporterService } from 'src/app/services/supporter.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PracticeService } from 'src/app/services/practice.service';
import { Practice } from 'src/app/models/practice';
import { CategoryService } from 'src/app/services/category.service';
import { TagsService } from 'src/app/services/tags.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-practice-content-course',
  templateUrl: './practice-content-course.component.html',
  styleUrls: ['./practice-content-course.component.scss']
})
export class PracticeContentCourseComponent implements OnInit {
  public practiceId;
  public practice;
  public loadedPractice:boolean=false;
  public loadedCourse:boolean = false;
  public course: Course;
  public courseId;
  public courseForm: FormGroup;
  public Editor = ClassicEditor;
  public supporters=[];
  public tutors=[];
  public categories=[];
  private courseTutors=[];
  private courseSupporters=[];
  public courseCategories=[];
  public courseTags=[];
  public tags=[];
  @ViewChild("descriptionEditor", {static: false}) descriptionEditor:any;
  dropdownSettings:IDropdownSettings;

  constructor(
    private _practice: PracticeService,
    private courseService: CourseService,
    private tutorService: TutorService,
    private supporterService: SupporterService,
    private _notify: NotificationService,
    private route: ActivatedRoute,
    private _cat: CategoryService,
    private _tag: TagsService
  ) {
    this.practiceId = this.route.snapshot.paramMap.get("practiceId");
    this.courseId = this.route.snapshot.paramMap.get("courseId");
    this.courseForm = new FormGroup({
      title: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
      description: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
      points: new FormControl('',[Validators.required]),
      published: new FormControl('',[Validators.required]),
      tutors: new FormControl(''),
      supporters: new FormControl(''),
      categories: new FormControl(''),
      tags: new FormControl('')
    });
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  public updateCourse(){
    this.course.title=this.courseForm.get('title').value;
    this.course.description=this.courseForm.get('description').value;
    this.course.points=this.courseForm.get('points').value;
    this.course.published=this.courseForm.get('published').value;
    if (this.course.title==''){
      return this._notify.showMessage('Course must have a title', 'OK');
    }
    this.courseService.updateCourse(this.course, this.courseForm.get('supporters').value, this.courseForm.get('tutors').value, this.courseForm.get('categories').value, this.courseForm.get('tags').value, null).subscribe(
      (res:Course) => {
        return this._notify.showMessage('Course updated.', 'OK');
      }
    );
  }

  public refreshCourseImage(){
    this.courseService.refreshCourseImage(this.course.id).subscribe(
      res=>{
        if (res.message=='success') {
          this.getCourse();
          this._notify.showMessage('Course image refreshed.', 'OK');
        } else {
          this._notify.showMessage('Error refreshing course image.', 'OK');
        }
      }
    );
  }

  getCourse(){
    this.courseService.getCourse(this.courseId).subscribe(course=>{
      this.course=course;
      this.courseForm.get('title').setValue(this.course.title);
      this.courseForm.get('description').setValue(this.course.description);
      this.courseForm.get('points').setValue(this.course.points);
      this.courseForm.get('published').setValue(this.course.published);
      this.course.tutors.forEach(item => { this.courseTutors.push(item.tutor_id) });
      this.courseForm.get('tutors').setValue(this.courseTutors);
      this.course.supporters.forEach(item => { this.courseSupporters.push(item.supporter_id) });
      this.courseForm.get('supporters').setValue(this.courseSupporters);
      this.course.category.forEach(item => { this.courseCategories.push(item.id) });
      this.courseForm.get('categories').setValue(this.courseCategories);
      this.course.tags.forEach(item=>{ this.courseTags.push(item.tag) });
      this.courseForm.get('tags').setValue(this.courseTags);
      this.loadedCourse = true;
    });
  }

  ngOnInit() {
    this.getPractice();
    this.getCourse();
    this.supporterService.getSupporters().subscribe(
      (data:any) => {
        this.supporters=data;
      }
    );
    this.tutorService.getTutors().subscribe(
      (data:any) => {
        this.tutors=data;
      }
    );
    this._cat.getCategories().subscribe(
      res=>{
        this.categories=res;
      }
    );
    this._tag.getPaginatedTags(1,99999999,'').subscribe(
      res=>{
        this.tags=res.data;
      }
    );
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'tag',
      enableCheckAll: false,
      searchPlaceholderText: 'Filter tags',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

}
